import { gql } from '@apollo/client';

export const GET_TEMPLATE_FOR_TENANT = gql`
  query TemplateForTenant($id: String!) {
    templateForTenant(id: $id) {
      id
      _WORKER_TERM_
      _CLIENT_TERM_
      _JOB_TERM_
      _TENANT_TERM_
      _CANCEL_TERM_
      _PAY_RATE_LEVEL_TERM_
      _INVOICE_NUMBER_PREFIX_
      _INVOICE_TERMS_
      _JOB_TABLE_FRONT_COLUMNS_
    }
  }
`;

// Template Mutations
export const UPDATE_TEMPLATE_FOR_TENANT = gql`
  mutation UpdateTemplateForTenant(
    $id: String!
    $_WORKER_TERM_: String
    $_CLIENT_TERM_: String
    $_JOB_TERM_: String
    $_TENANT_TERM_: String
    $_REQUIREMENT_TERM_: String
    $_CANCEL_TERM_: String
  ) {
    updateTemplateForTenant(
      id: $id
      _WORKER_TERM_: $_WORKER_TERM_
      _CLIENT_TERM_: $_CLIENT_TERM_
      _JOB_TERM_: $_JOB_TERM_
      _TENANT_TERM_: $_TENANT_TERM_
      _REQUIREMENT_TERM_: $_REQUIREMENT_TERM_
      _CANCEL_TERM_: $_CANCEL_TERM_
    ) {
      id
      _WORKER_TERM_
      _CLIENT_TERM_
      _JOB_TERM_
      _TENANT_TERM_
      _REQUIREMENT_TERM_
      _CANCEL_TERM_
      _REQUIREMENT_LIST_
    }
  }
`;

export const ADD_REQUIREMENT_TO_TENANT = gql`
  mutation AddRequirementToTenant($id: String!, $requirement: String!) {
    addRequirementToTenant(id: $id, requirement: $requirement) {
      id
      _REQUIREMENT_LIST_
    }
  }
`;

export const REMOVE_REQUIREMENT_FROM_TENANT = gql`
  mutation RemoveRequirementFromTenant($id: String!, $requirement: String!) {
    removeRequirementFromTenant(id: $id, requirement: $requirement) {
      id
      _REQUIREMENT_LIST_
    }
  }
`;
